import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function TopicModal({ open, onClose, onSave, topic, subjectId }) {
  const [formData, setFormData] = useState({
    name: '',
    subject: subjectId,
    order: 0,
  });

  useEffect(() => {
    if (topic) {
      setFormData({
        name: topic.name || '',
        subject: topic.subject || subjectId,
        order: topic.order || 0,
      });
    } else {
      setFormData({ name: '', subject: subjectId, order: 0 });
    }
  }, [topic, subjectId, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...formData, subject: subjectId });
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="topic-modal">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Manrope, sans-serif' }}>
            {topic ? 'Konuyu Düzenle' : 'Yeni Konu Ekle'}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="topic-name">Konu Adı</Label>
            <Input
              id="topic-name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Örn: Türev"
              required
              data-testid="topic-name-input"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="topic-order">Sıra</Label>
            <Input
              id="topic-order"
              type="number"
              value={formData.order}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) || 0 })}
              data-testid="topic-order-input"
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose}>
              İptal
            </Button>
            <Button 
              type="submit" 
              className="bg-teal-700 hover:bg-teal-800"
              data-testid="topic-save-btn"
            >
              Kaydet
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
